import { Button, Flex, Text } from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';

import { REFERRAL_PAYOUT_AMOUNT_USD } from '../../constants/referral';
import { capitalizeWords } from '../../utils/strings';
import Modal from '../Modal';

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  code: string | null;
  firstName?: string | null;
};

const ReferralDetails = ({ isOpen, setIsOpen, code, firstName }: Props) => {
  const onModalClose = () => setIsOpen(false);
  const capitalizedName = capitalizeWords(firstName || '') || '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onModalClose}
      size="2xl"
      title={`${
        (capitalizeWords(firstName || '') || '').trim()
          ? `${capitalizeWords(firstName || '')}'s Referral Details`
          : 'Referral Details'
      }`}
    >
      {code && (
        <Flex
          justifyContent="center"
          fontSize={16}
          fontWeight={400}
          color="leaseEndBlue"
          flexDir="column"
          gap={8}
        >
          <Text as="p" textAlign="center">
            When you secure a loan and end your lease using {capitalizeWords(firstName || '')}'s
            referral{' '}
            <Text as="span" fontWeight={700} display="block">
              both you and {capitalizedName} will receive ${REFERRAL_PAYOUT_AMOUNT_USD} in cash!
            </Text>
          </Text>
          <Text as="p" textAlign="center">
            Don't forget it takes just a few minutes online to get us your info - from there, it's
            all on us!
          </Text>
          <Flex justifyContent="center" w="auto">
            <Button onClick={onModalClose}>Let's Wrap this Up!</Button>
          </Flex>
        </Flex>
      )}
    </Modal>
  );
};

export default ReferralDetails;
